// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"4b963b5e","265":"9ecc8f97","309":"c5ff8ee9","392":"af5b6077","576":"81c1fc39","787":"0d66e12a","892":"bb955acf"}[chunkId] + ".chunk.js";
};